<app-navbar></app-navbar>

<!-- <div class="main-package-container">
    <div class="left">
      <h2>Premium Features</h2>
      <h3>and tools for an enhanced training experience.</h3>
      <ul>
        <li>Access advanced tools</li>
        <li>Personalized support</li>
        <li>Exclusive features for a smoother eLearning experience.</li>
        <li>Priority access to live sessions and webinars</li>
        <li>Progress tracking and performance insights</li>
         <li>Interactive modules and real-time feedback</li>
      </ul>
      <button >Explore our Packages</button>
    </div>
    <div class="right">
      <img src="../../../assets/about/executie_coaches.jpeg" alt="">
    </div>
</div> -->

<div class="Flexible-learning-container">
  <!-- <div class="heading">
        <div class="line"></div>
        <h5>Flexible Learning</h5>
        <div class="line"></div>
    </div> -->
  <p>Our Executive Coaching Certification Programs</p>

  <div class="cards">
    <!-- Platinum Card -->
    <div class="card1">
      <div class="image">
        <img src="../../../assets/platinum badge.jpeg" alt="Platinum Badge" height="30px" width="30px">
      </div>
      <h3>Platinum</h3>
      <p>The ultimate certification experience for aspiring Executive Coaches who want to master their craft, gain ICF
        credentials, and launch a thriving coaching practice.</p>
      <h5>$12,995</h5>
      <hr>

      <div class="include">
        <h4>Includes</h4>
        <ul>
          <li><i class="fa-regular fa-circle-check"></i> Live Virtual Intensive 2-Day Seminar</li>
          <li><i class="fa-regular fa-circle-check"></i> 10 Hours ICF Mentor Coaching</li>
          <li><i class="fa-regular fa-circle-check"></i> ICF Curriculum and Practice Test</li>
          <li><i class="fa-regular fa-circle-check"></i> Two-Year Membership to NexGen Executive Coaching Academy</li>
          <li><i class="fa-regular fa-circle-check"></i> On-Demand and Live Training Video Library</li>
          <li><i class="fa-regular fa-circle-check"></i> AI Co-Pilot Coach Assistant</li>
          <li><i class="fa-regular fa-circle-check"></i> First-Year ICF Membership Included ($245 Value)</li>
          <li><i class="fa-regular fa-circle-check"></i> Exclusive Certification after 2-Day Seminar and Passing Exam
          </li>
          <li><i class="fa-regular fa-circle-check"></i> Completion within 5–6 Months After 100 Hours of Paid Coaching
          </li>
          <li><i class="fa-regular fa-circle-check"></i> 60 Hours of Education</li>
          <li><i class="fa-regular fa-circle-check"></i> ICF Certificate (Ready to Test) for ACC or PCC</li>
        </ul>

        <h3><i class="fa-regular fa-circle-check"></i> EXCLUSIVE FEATURES</h3>
        <div class="exclusive">
          <ul>
            <li>Real-Time Barter Coaching Platform</li>
            <li>On-Demand Executive Coaching Videos</li>
            <li>Customizable AI Co-Pilot Coach Assistant</li>
            <li>One-Year Free ICF Membership ($270 Value)</li>
            <li>Join-Any-Time Live Training Webinars</li>
            <li>NexGen Executive Coaching Academy Mobile App (iOS & Android)</li>
            <li>Access to Specialty Certifications</li>
          </ul>
        </div>

        <h3><i class="fa-regular fa-circle-check"></i> ICF CERTIFICATION</h3>
        <ul>
          <li>ICF Education Hours</li>
          <li>60 Hours for ACC (Level I)</li>
          <li>125 Hours for PCC (Level II)</li>
        </ul>
        <p>Complete in just 5–6 months</p>
      </div>
      <div class="button-wrapper">
        <button routerLink="/platinum-brochure">More Information</button>
        <button style="margin-block: 20px;" (click)="goToPlatinumBilling()" [disabled]="isLoading">
          {{ isLoading ? 'Please wait...' : 'Buy Now' }}
        </button>

      </div>
    </div>

    <!-- Gold Card -->
    <div class="card1">
      <div class="image">
        <img src="../../../assets/gold badge.jpeg" alt="Gold Badge" height="30px" width="30px">
      </div>
      <h3>Gold Package</h3>
      <p>Designed for professionals ready to elevate their coaching expertise, the Gold Package provides a balanced mix
        of intensive training, on-demand learning, and cutting-edge AI-driven coaching tools.</p>
      <h5>$10,995</h5>
      <hr>

      <div class="include">
        <h4>Includes</h4>
        <ul>
          <li><i class="fa-regular fa-circle-check"></i> Virtual Intensive 2-Day Seminar</li>
          <li><i class="fa-regular fa-circle-check"></i> Individual EQ 2.0i Assessment</li>
          <li><i class="fa-regular fa-circle-check"></i> Business Builder Workshop</li>
          <li><i class="fa-regular fa-circle-check"></i> Pre-Recorded Video & Seminar Library</li>
          <li><i class="fa-regular fa-circle-check"></i> AI Co-Pilot Coach Assistant</li>
          <li><i class="fa-regular fa-circle-check"></i> Assessment Quiz</li>
          <li><i class="fa-regular fa-circle-check"></i> Certification After Seminar and 60 Hours of Education</li>
          <li><i class="fa-regular fa-circle-check"></i> 2-Day Live Virtual Workshop (Professional Certification)</li>
        </ul>

        <h3><i class="fa-regular fa-circle-check"></i> EXCLUSIVE FEATURES</h3>
        <div class="exclusive">
          <ul>
            <li>One-Year Access to AI-Driven LMS Platform</li>
            <li>Real-Time Barter Coaching Platform</li>
            <li>Customizable AI Co-Pilot Coach Assistant</li>
            <li>Patented AI-Driven Coaching Framework</li>
            <li>Join-Any-Time Live Training Webinars</li>
            <li>NexGen Executive Coaching Academy App (Android/iOS)</li>
            <li>Access to Specialty Certifications</li>
          </ul>
        </div>

        <h3><i class="fa-regular fa-circle-check"></i> FLEXIBLE PLATINUM UPGRADE OPTIONS</h3>
        <ul>
          <li>Upgrade to Platinum for $2,000 anytime during or after Gold</li>
          <li>All Gold training counts toward Platinum with no progress lost</li>
          <li>Switch seamlessly between programs with no deadlines or penalties</li>
          <li>Maintain lifetime eligibility to upgrade</li>
        </ul>
      </div>
      <div class="button-wrapper">
        <button routerLink="/gold-brochure">
          More Information
        </button>
        <button style="margin-top: 25px;" (click)="goToGoldBilling()" [disabled]="isLoading">
          {{ isLoading ? 'Please wait...' : 'Buy Now' }}
        </button>
      </div>
    </div>
    <!-- Sales Leadership Card -->
    <!-- <div class="card1">
            <div class="image">
                <img src="../../assets/badge.jpeg" alt="Sales Leadership Badge" height="30px" width="30px">
            </div>
            <h3>Sales Leadership Certification</h3>
            <p>A flexible, self-paced certification program designed for professionals who want to develop executive coaching skills without pursuing ICF certification.</p>
            <h5>Coming Soon..</h5>
            <hr>

            <div class="include">
                <h4>Includes</h4>
                <ul>
                    <li><i class="fa-regular fa-circle-check"></i> Team Coaching Certification</li>
                    <li><i class="fa-regular fa-circle-check"></i> C-Level Leadership Coaching Certification</li>
                    <li><i class="fa-regular fa-circle-check"></i> Sales Leadership Coaching Certification</li>
                    <li><i class="fa-regular fa-circle-check"></i> Executive Coaching Business Builder Certification</li>
                </ul>

      <div class="button-container">
        <button routerLink="/leadership-certificates">More Information</button>
      </div>

       <h3 style="margin-top: 70px;">BUSINESS BUILDER WORKSHOP</h3>
                <p>This one-day virtual workshop is designed to equip aspiring executive coaches with essential skills and knowledge to launch their own coaching business.</p>
                <h5>Coming Soon..</h5>
                <hr>

                <h4>Includes</h4>
                <ul>
                    <li><i class="fa-regular fa-circle-check"></i> Live Interactive Virtual Seminar</li>
                    <li><i class="fa-regular fa-circle-check"></i> Practical Application Activities</li>
                    <li><i class="fa-regular fa-circle-check"></i> One-Month Access to NexGen Executive Coaching Academy LMS</li>
                    <li><i class="fa-regular fa-circle-check"></i> Certification Exam</li>
                    <li><i class="fa-regular fa-circle-check"></i> Customized Business Canvas Framework</li>
                </ul>
            </div>
      <div class="button-wrapper">
        <button style="margin-top: 195px;" class="cardButton" routerLink="/business-builder">More Information</button>
      </div>
    </div> -->

  </div>
</div>

<div class="Fast-Track-container">
  <div class="Fast-Track-inner-content">
    <div class="contant">
      <div class="left">
        <h3>Fast-Track Your Executive Coaching Certification with Unparalleled Flexibility and Cutting-Edge Training
        </h3>
        <p>NexGen Executive Coaching Academy Platinum Package is designed for professionals who want to earn their
          ICF-accredited Executive Coach Certification without disrupting their careers.</p>
      </div>
      <div class="right">
        <img src="../../assets/programsPage/2.png" alt="">
      </div>
    </div>
    <p class="bottom-paragraph">Unlike traditional programs, NexGen Executive Coaching Academy offers flexibility with
      join-anytime enrollment and evening/weekend live training sessions. You’ll gain access to elite coaching
      strategies, AI-powered learning, and a network of ICF-Certified Executive Coaches with Fortune 500 work experience
      designed to help you become a world-class Executive Coach in months, not years.</p>
  </div>
</div>

<app-footer></app-footer>